import {jwtServerInstance} from "../index";
import {getTokenUser} from "@/lib/utils";
import qs from	'qs'
import {getJwtToken} from "../../lib/utils";

export const queryNotice = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cnotices/query',
        method:'post',
        data:qs.stringify({
            keyWords: queryForm.searchKeyWord,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const updateNotice = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cnotices/update',
        method:'post',
        data:dialogForm
    })
}

export const updateNoticeIsNotToday = (b2cNoticesId) => {
    return jwtServerInstance.request({
        url:'/b2cnotices/upisnottoday',
        method:'post',
        data:qs.stringify({
            b2cNoticesId: b2cNoticesId
        })
    })
}

export const queryCustomerAccountLogs = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2customer/queryaccountlog',
        method:'post',
        data:qs.stringify({
            userId: queryForm.userId,
            serialType:queryForm.serialType,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//新增佣金统计接口
export const queryCommissionInfo = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2customer/querycommoney',
        method:'post',
    })
}

// 权益统计接口：当日/昨日/当月/总 收益、订单、推荐
export const queryBenefitStatistics = () => {
    return jwtServerInstance.request({
        url:'/b2customer/querybenefitstatistics',
        method:'post',
    })
}



export const queryMsgList = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/imessagectr/querymsg',
        method:'post',
        data: qs.stringify({
            userName: queryForm.userName,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    });
}

export const queryUserMsgList = (queryForm)=>{
    return jwtServerInstance.request({
        url: '/imessagectr/queryusermsg',
        method: 'post',
        data:qs.stringify({
            activeUserName: queryForm.activeUserName
        })
    });
}

export const queryUnReadMsgNum = ()=>{
    return jwtServerInstance.request({
        url: '/imessagectr/queryunredmsg',
        method: 'post'
    });
}


export const sendImageToServer = (file) =>{
    return jwtServerInstance.request({
        headers:{
            'Content-Type': 'multipart/form-data',
            'JWTHeaderName': getJwtToken()
        },
        url: '/imessagectr/file/upload',
        method: 'post',
        data: file
    });
}
